export const ACCOUNT_TYPE_STAFF = "3";
export const ACCOUNT_TYPE_CREATOR = "300001";

export const TARIFF_FREE = "300000";

export const isStaff = (accountDetails) =>
  accountDetails?.accountTypeId === ACCOUNT_TYPE_STAFF;

export const isCreator = (accountDetails) =>
  accountDetails?.accountTypeId === ACCOUNT_TYPE_CREATOR;

export const isStaffOrCreator = (accountDetails) =>
  isStaff(accountDetails) || isCreator(accountDetails);

export const isOfflineAccount = (accountDetails) =>
  accountDetails?.isOfflineAccount === true;

export const isApiKeyAccount = (accountDetails) =>
  accountDetails?.isApiKeyAccount === true;

export const isFreeUser = () =>
  localStorage.getItem('user_trial_sub') === 'true' && !isLifetimeLicence();

export const isLifetimeLicence = () =>
  localStorage.getItem('user_lifetime_licence') === 'true';

export const setFreeUserFlag = (tariffId, hasApplicationPurchase = false) => {
  localStorage.setItem('user_trial_sub', tariffId == TARIFF_FREE ? 'true' : 'false');
  localStorage.setItem('user_lifetime_licence', hasApplicationPurchase ? 'true' : 'false');
};
